<template>
  <div id="committee-member-create">
    <!-- ===== HEADER ===== -->
    <v-card class="create-header-card">
      <v-row no-gutters class="pa-6" align="center">
        <v-col cols="auto">
          <div class="header-icon-box-create">
            <v-icon size="32" color="white">mdi-plus-circle-outline</v-icon>
          </div>
        </v-col>
        <v-col cols="auto" class="ml-4">
          <h2 class="header-title-create">{{ PageTitle }}</h2>
          <p class="header-subtitle-create">Add a new member to your committee team</p>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-btn icon dark @click="closePrompt" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- ===== FORM CARD ===== -->
    <v-card class="form-card pa-8">
      <v-form ref="form1" v-model="valid1" lazy-validation>
        <!-- REQUIRED FIELDS NOTICE -->
        <div class="required-notice mb-6">
          <v-icon color="#ff9800" size="20">mdi-alert-circle</v-icon>
          <span><span class="text-danger" style="color: #e74c3c; font-weight: 700;">*</span> Indicates required field</span>
        </div>

        <!-- MEMBER SELECTION -->
        <div class="form-section">
          <h3 class="form-section-title">
            <v-icon color="#0097d7" left>mdi-account-plus</v-icon>
            Select Member
          </h3>

          <v-autocomplete
            :reduce="(option) => option.value"
            :loading="MemberIdOptionsLoading"
            :items="MemberIdOptions"
            :rules="MemberIdRules"
            v-model="MemberId"
            required
            outlined
            dense
            class="member-select"
            placeholder="Choose a member from the list"
            clearable
          >
            <template v-slot:selection="{ item }">
              <v-avatar size="32" class="mr-2">
                <img :src="item.photo" :alt="item.text" />
              </v-avatar>
              <span class="font-weight-bold">{{ item.text }}</span>
            </template>
            <template v-slot:item="{ item }">
              <v-avatar size="40" class="mr-3">
                <img :src="item.photo" :alt="item.text" />
              </v-avatar>
              <span>{{ item.text }}</span>
            </template>
            <template v-slot:prepend-inner>
              <v-icon color="#0097d7">mdi-account-search</v-icon>
            </template>
          </v-autocomplete>
        </div>

        <!-- INFO BOX -->
        <div class="info-box mt-6 pa-4">
          <v-icon color="#4caf50" left size="20">mdi-information-outline</v-icon>
          <span style="color: #333; font-size: 13px;">
            <strong>Note:</strong> The first member added will be automatically designated as the Committee Chairman
          </span>
        </div>

        <!-- ACTION BUTTONS -->
        <v-card-actions class="form-actions mt-8">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closePrompt"
            outlined
            color="#999"
            class="action-btn-secondary"
          >
            <v-icon left>mdi-close</v-icon>
            Cancel
          </v-btn>
          <v-btn
            :disabled="!valid1"
            @click.prevent="confirmAlert"
            :loading="SubmitFlag"
            elevation="2"
            color="#0097d7"
            class="action-btn-primary white--text"
          >
            <v-icon left>mdi-check-circle</v-icon>
            Save Member
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
    recordData: {
      type: Array,
      required: true,
    },
    LomCode: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,
      rows: [],
      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberIdOptionsLoading: false,
      MemberIdOptions: [],
      MemberId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;

        this.pageData();
      }
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberId: function () {
      console.log("watch MemberId");
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log({ member });
      }
    },
  },
  created() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "mol_committee",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.getMemberIdOptions();
    },
    pageData() {
      console.log("pageData called");
      this.getMemberIdOptions();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
    },
    closePrompt() {
      console.log("closePrompt called");
      console.log(this.ResultFlag);
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 8,
        LomCode: this.LomCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Add Member?",
          text: "Are you sure you want to add this member to the committee?",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: `Confirm`,
          confirmButtonColor: "#0097d7",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#999",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("info", "You cancelled the action", false);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields");
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/mission-onelakh/add-member";
        var upload = {
          UserInterface: 1,
          Member: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.resetForm();
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
              thisIns.toast("success", output);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.toast("error", "An error occurred while saving");
          });
      } else {
        var message = "Kindly fill the required fields";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
$navy: #3a67b1;
$aqua: #0097d7;
$text-off-black: #0a0f29;
$text-white: #ffffff;

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
}

#committee-member-create {
  .create-header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    border-radius: 12px 12px 0 0 !important;
    border: none !important;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: radial-gradient(circle at top right, rgba(255,255,255,0.1) 0%, transparent 60%);
      animation: float 4s ease-in-out infinite;
    }

      .v-row {
        position: relative;
        z-index: 2;
      }
    }

    .header-icon-box-create {
      background: rgba(255,255,255,0.2);
      backdrop-filter: blur(10px);
      border-radius: 12px;
      padding: 10px;
      border: 1px solid rgba(255,255,255,0.3);
      animation: float 4s ease-in-out infinite;
      flex-shrink: 0;
    }

    .header-title-create {
      font-size: 20px !important;
      font-weight: 700 !important;
      color: $text-white !important;
      text-shadow: 0 2px 4px rgba(0,0,0,0.2);
      animation: slideDown 0.8s ease-out;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1.2;
    }

    .header-subtitle-create {
      font-size: 12px;
      color: rgba(255,255,255,0.9);
      margin: 4px 0 0 0;
      padding: 0;
      font-weight: 500;
      letter-spacing: 0.3px;
      animation: slideInUp 0.8s ease-out 0.1s backwards;
    }

    .close-btn {
      transition: all 0.3s ease !important;

      &:hover {
        background: rgba(255,255,255,0.2) !important;
        transform: rotate(90deg);
      padding: 12px 16px;
      border-radius: 8px;
      font-size: 13px;
      color: #333;
    }

    .form-section {
      margin-bottom: 24px;

      .form-section-title {
        font-size: 16px;
        font-weight: 700;
        color: $navy;
        display: flex;
        align-items: center;
        margin: 0 0 16px 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .member-select {
        border-radius: 8px !important;

        ::v-deep .v-input__control {
          border-radius: 8px !important;
        }
      }
    }

    .info-box {
      background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
      border: 1px solid rgba(76,175,80,0.2);
      border-radius: 8px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
      font-size: 13px;
      color: #2e7d32;
    }

    .form-actions {
      border-top: 1px solid #e0e0e0;
      background: linear-gradient(135deg, #f5f7fa 0%, #eef2f7 100%);
      gap: 8px;

      .action-btn-primary {
        border-radius: 8px;
        padding: 10px 32px !important;
        font-weight: 700;
        letter-spacing: 0.4px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(0,151,215,0.3) !important;
        }

        &:disabled {
          opacity: 0.6;
        }
      }

      .action-btn-secondary {
        border-radius: 8px;
        padding: 10px 28px !important;
        font-weight: 700;
        letter-spacing: 0.4px;
        transition: all 0.3s ease !important;

        &:hover {
          background: #f5f5f5 !important;
          transform: translateY(-2px);
        }
      }
    }
  }
}
</style>
